var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden go_win_obj",style:(_vm.extendStyle),attrs:{"id":_vm.winId}},[_c('div',{staticClass:"toast-ctl toast-top-right",staticStyle:{"position":"absolute"},style:(_vm.getMaxZIndex),attrs:{"id":_vm.msgIdStr,"aria-live":"polite","role":"alert"}}),_vm._v(" "),_c('Row',{staticClass:"wh100b"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/go-add-mod-win.vue